import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import { initReactI18next } from 'react-i18next';
import { startLoading, endLoading } from '../store/loader.slice';
import store from '../store';
import * as cookie from './cookie';
import axios from 'axios';

const uri = '/mgmt/locales';
const language = cookie.get('language') || 'ko';

const loadResources = async () => {
  store.dispatch(startLoading());

  return await axios.get(uri)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      console.error(e);
      return {
        "ko": { "translation": { "defaultTitle": "통합관리시스템" } },
        "en": { "translation": { "defaultTitle": "SUM" } }
      }
    })
    .finally(() => {
      store.dispatch(endLoading());
    });
}

const backendOptions = {
  backend: Backend,
  allowMultiLoading: true,
  backendOption: {
    request: (options: any, url: any, payload: any, callback: any) => {
      try {
        loadResources()
          .then(res => {
            callback(null, { data: res, status: 200 });
          });
      } catch (e) {
        console.error(e);
        callback(null, { status: 500 });
      }
    }
  }
};

i18n
  .use(BackendAdapter)
  .use(initReactI18next)
  .init({
    backend: backendOptions,
    fallbackLng: language,
    lng: language,
    debug: false,
    load: "languageOnly",
    ns: ["translation"],
    defaultNS: "translation",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: false,
    }
  });

export default i18n;
